import { get } from "./get"
import subthemes from "./subthemes"

const themes = {
  get,
  subthemes,
}

export default themes
